var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2635",
    "data-name": "Group 2635",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.001,
    height: 24,
    viewBox: "0 0 24.001 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_15876",
    "data-name": "Path 15876",
    d: "M212.6,43.17a12,12,0,1,1,12-12A12.015,12.015,0,0,1,212.6,43.17Zm0-22.857A10.857,10.857,0,1,0,223.458,31.17,10.87,10.87,0,0,0,212.6,20.313Z",
    transform: "translate(-200.6 -19.17)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_15877",
    "data-name": "Path 15877",
    d: "M228.71,38.565a3.033,3.033,0,0,0-.922-1.949,3.149,3.149,0,0,0-2.1-.849,41.311,41.311,0,0,0-5.648.062,2.88,2.88,0,0,0-2.47,2.219,31.675,31.675,0,0,0-.058,6.409,2.89,2.89,0,0,0,2.3,2.492,33.565,33.565,0,0,0,6.322.04,2.9,2.9,0,0,0,2.5-2.285A36.481,36.481,0,0,0,228.71,38.565Zm-1.049,5.709A1.932,1.932,0,0,1,225.843,46a33.719,33.719,0,0,1-5.888-.084,1.875,1.875,0,0,1-1.421-1.614,38.01,38.01,0,0,1,0-5.764,1.928,1.928,0,0,1,1.811-1.716,40.184,40.184,0,0,1,5.622.022,1.936,1.936,0,0,1,1.723,1.822A42.473,42.473,0,0,1,227.661,44.275Zm-4.565-5.79a2.928,2.928,0,1,0,2.926,2.929A2.927,2.927,0,0,0,223.1,38.485Zm-.022,4.817a1.893,1.893,0,1,1,1.909-1.876A1.892,1.892,0,0,1,223.074,43.3Zm3.749-4.93a.687.687,0,1,1-.685-.689A.687.687,0,0,1,226.823,38.372Z",
    transform: "translate(-210.973 -29.388)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_15878",
    "data-name": "Path 15878",
    d: "M228.71,38.565a3.033,3.033,0,0,0-.922-1.949,3.149,3.149,0,0,0-2.1-.849,41.311,41.311,0,0,0-5.648.062,2.88,2.88,0,0,0-2.47,2.219,31.675,31.675,0,0,0-.058,6.409,2.89,2.89,0,0,0,2.3,2.492,33.565,33.565,0,0,0,6.322.04,2.9,2.9,0,0,0,2.5-2.285A36.481,36.481,0,0,0,228.71,38.565Zm-1.049,5.709A1.932,1.932,0,0,1,225.843,46a33.719,33.719,0,0,1-5.888-.084,1.875,1.875,0,0,1-1.421-1.614,38.01,38.01,0,0,1,0-5.764,1.928,1.928,0,0,1,1.811-1.716,40.184,40.184,0,0,1,5.622.022,1.936,1.936,0,0,1,1.723,1.822A42.473,42.473,0,0,1,227.661,44.275Zm-4.565-5.79a2.928,2.928,0,1,0,2.926,2.929A2.927,2.927,0,0,0,223.1,38.485Zm-.022,4.817a1.893,1.893,0,1,1,1.909-1.876A1.892,1.892,0,0,1,223.074,43.3Zm3.749-4.93a.687.687,0,1,1-.685-.689A.687.687,0,0,1,226.823,38.372Z",
    transform: "translate(-210.973 -29.388)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagram-icon.5a08428fe895d111a031e908577d80dc.svg";
export { ForwardRef as ReactComponent };